import React, { useState, useEffect, Link } from "react";
import MicRecorder from 'mic-recorder-to-mp3';
import { useSelector, useDispatch } from 'react-redux';
import { FaMicrophone, FaStop } from 'react-icons/fa';
import { alert_error, alert_success } from '../../../AppContext';
import { update_blob_data, update_comments_orders, update_amount_orders } from '../../../order/orders/actions.js';
import { Cookies } from '../../../index.js';
import Language_i18 from '../../../js/useNationalLanguage.jsx';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const MyComponent = ({ inputType, handleRadioChange, handleFileChange, handleTextChange, Text, services_orders, audioDuration, setaudioDuration }) => {
    const { lang } = Language_i18();
    const translations = {
        vi: {
            upload_file: 'Tải file lên',
            record_audio: 'ghi âm',
            text_input: 'Nhập văn bản',
            voice_ai: 'Chuyển đổi giọng nói theo âm của bạn 🎤',
            vietnamese: 'Tiếng việt',
            english: 'Tiếng anh',
            choose_method: 'Chọn phương thức:',
            upload_pdf: 'Tải lên file PDF:',
            upload_audio: 'Tải lên file audio:',
            audio_duration: 'Thời gian audio',
            voice_clone_notice: 'Chuyển đổi mô phỏng lại giọng nói của bạn 🎙️',
            enter_link: 'Nhập liên kết...',
            enter_text: 'Nhập văn bản...'
        },
        en: {
            upload_file: 'Upload file',
            record_audio: 'Record audio',
            text_input: 'Enter text',
            voice_ai: 'Convert to your voice tone 🎤',
            vietnamese: 'Vietnamese',
            english: 'English',
            choose_method: 'Choose method:',
            upload_pdf: 'Upload PDF:',
            upload_audio: 'Upload audio file:',
            audio_duration: 'Audio duration',
            voice_clone_notice: 'Convert to mimic your voice 🎙️',
            enter_link: 'Enter link...',
            enter_text: 'Enter text...'
        }
    };
    const [inputOptions, set_inputOptions] = useState('');
    const [options_voice, set_options_voice] = useState('');

    const blob_data = useSelector(state => state.blob_data);
    const amount_orders = useSelector(state => state.amount_orders);

    useEffect(() => {
        if (services_orders.category.includes("speech_text")) {
            set_inputOptions([
                { label: translations[lang]?.upload_file, value: 'file_audio' },
                { label: translations[lang]?.record_audio, value: 'record_audio' },
                // { label: 'Nhập link', value: 'link_input' },
            ]);
        }
        else if (services_orders.category.includes("text_speech")) {
            const apikey = Cookies.get('apikey');
            if (apikey) {
                set_inputOptions([
                    { label: translations[lang]?.text_input, value: 'text_input' },
                    // { label: 'Tải lên file PDF', value: 'file_pdf' },
                    // { label: 'Tải lên ảnh', value: 'file_image', redirect: '/ai/plans/image_text' },
                    { label: translations[lang]?.voice_ai, value: 'voice_ai' }
                ]);
            }
            else if (!apikey) {
                set_inputOptions([
                    { label: translations[lang]?.text_input, value: 'text_input' },
                    // { label: 'Tải lên file PDF', value: 'file_pdf' },
                    // { label: 'Tải lên ảnh', value: 'file_image', redirect: '/ai/plans/image_text' },
                ]);
            }
        }
        set_options_voice([
            { label: translations[lang]?.vietnamese, value: 'lang_vie' },
            { label: translations[lang]?.english, value: 'lang_en' }
        ]);
    }, [services_orders, lang]);
    const dispatch = useDispatch();
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    const set_blob_data = (value) => {
        dispatch(update_blob_data(value));
    };
    const [isRecording, setIsRecording] = useState(false);
    const [blobURL, setBlobURL] = useState('');
    const [isBlocked, setIsBlocked] = useState(false);
    const [isRecordingok, setIsRecordingok] = useState(false);
    const [dungghi, setdungghi] = useState(false);
    const [startTime, setstartTime] = useState(false);
    const stopRecordingok = () => {
        // socket.disconnect();
        setdungghi(false);
        Mp3Recorder.stop()
            .getMp3()
            .then(([buffer, blob]) => {

                setIsRecording(false);
                const blobURL = URL.createObjectURL(blob);
                const endTime = Date.now();
                // console.log(endTime);
                const ok_time = Math.floor((endTime - startTime) / 1000 + 1);
                setaudioDuration(ok_time); // Tính số giây đã ghi âm
                console.log("Số giây âm thanh: ", ok_time);
                setBlobURL(blobURL);
                sendAudioData(blob);
                set_blob_data(blob);
                set_amount_orders(ok_time);
            })
            .catch((e) => console.log(e));

    };
    function stopRecording() {
        setdungghi(true);
        setTimeout(() => {
            stopRecordingok();
        }, 1000);
    }

    const sendAudioData = (audioBlob) => {
        const formData = new FormData();
        formData.append('file', audioBlob); // blob là biến chứa dữ liệu audioBlob
    };

    const handleRecording = () => {
        // console.log(isRecordingok);
        setIsRecordingok(!isRecordingok);
        if (isRecordingok == true) {
            stopRecording();
        }
        else if (isRecordingok == false) {
            setaudioDuration(false);
            startRecording();
        }

    };
    const startRecording = () => {
        if (isBlocked) {
            alert_error('Mic bị lỗi');
        }
        else {
            // socket.on('startRecording', () => {
            //   // Xử lý logic khi bắt đầu ghi âm
            //   console.log('Đã bắt đầu ghi âm');
            // });
            Mp3Recorder.start()
                .then(() => {
                    setstartTime(Date.now());
                    setIsRecording(true);
                    startSendingAudio();
                })
                .catch((e) => console.error(e));
        }
    };
    const startSendingAudio = () => {
        Mp3Recorder
            .getMp3()
            .then(([buffer, blob]) => {
                // sendAudioData(blob);
            })
            .catch((e) => console.log(e));
    };
    return (
        <>
            {
                inputOptions &&
                (<>
                    <div className="mb-0 mt-1">
                        <div className="flex space-x-2">
                            <label className="block mb-0 text-sm font-medium text-gray-700">{translations[lang]?.choose_method}</label>
                            {inputOptions.map((option) => (
                                <label key={option.value} className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="inputType"
                                        value={option.value}
                                        checked={inputType === option.value}
                                        onChange={handleRadioChange}
                                        className="form-radio"
                                        data-option={JSON.stringify(option)}  // Lưu toàn bộ đối tượng option trong dataset
                                    />
                                    <span className="ml-2">{option.label}</span>
                                </label>
                            ))}
                        </div>
                        {inputType === 'file_pdf' && (
                            <div className="mt-0 mb-1">
                                <label className="block mb-1 text-sm font-medium text-gray-700">{translations[lang]?.upload_pdf}</label>
                                <input
                                    type="file"
                                    accept=".pdf"
                                    onChange={handleFileChange}
                                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
                                />
                            </div>
                        )}
                        {(inputType === 'file_audio' || inputType === 'voice_ai') && (
                            <div className="mt-0 mb-1">
                                <label className="block mb-1 text-sm font-medium text-gray-700">{translations[lang]?.upload_audio}</label>
                                <input
                                    type="file"
                                    accept=".mp3, .wav, .ogg, .m4a" // Chỉ cho phép các định dạng âm thanh
                                    onChange={handleFileChange}
                                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
                                />
                                {
                                    audioDuration && (<>
                                        {translations[lang]?.audio_duration} {audioDuration} s
                                    </>)
                                }
                            </div>
                        )}


                        {(inputType === 'record_audio') && (
                            <>
                                <div className="text-center ">
                                    <div className="relative mt-2 mb-1 inline-block">
                                        <button
                                            className={`bg-green-500 hover:bg-green-600 text-white rounded-full w-28 h-28 flex items-center justify-center focus:outline-none ${isRecording ? 'ring-2 ring-green-600' : ''
                                                }`}
                                            onClick={handleRecording}
                                        >
                                            {isRecording ? (
                                                <FaStop className="text-2xl" />
                                            ) : (
                                                <FaMicrophone className="text-2xl" />
                                            )}
                                            {isRecording && (
                                                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                                                    <div className="absolute w-28 h-28 bg-green-500 opacity-50 rounded-full animate-pulse"></div>
                                                    <div className="absolute w-32 h-32 bg-green-500 opacity-20 rounded-full animate-pulse"></div>
                                                    <div className="absolute w-36 h-36 bg-green-500 opacity-10 rounded-full animate-pulse"></div>
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </div>
                                {blobURL && !isRecordingok && (
                                    <>
                                        <audio src={blobURL} className="mt-2" controls="controls" />
                                    </>
                                )}
                                {
                                    audioDuration && (<>
                                        {translations[lang]?.audio_duration} {audioDuration}
                                    </>)
                                }
                            </>
                        )}
                        {/* Hiển thị textarea nếu người dùng chọn "Nhập văn bản" */}
                        {(!services_orders.category.includes("speech_text")) && (
                            <>
                                {((inputType === 'text_input' || inputType === 'voice_ai') || Text) &&
                                    (
                                        <>
                                            {((inputType === 'voice_ai') || Text) &&
                                                (
                                                    <>{translations[lang]?.voice_clone_notice}</>
                                                )}
                                            <textarea
                                                className="w-full h-40 border mb-1 border-gray-300 rounded p-2 resize-none"
                                                placeholder={translations[lang]?.enter_text}
                                                value={Text}
                                                onChange={handleTextChange}
                                            />
                                        </>
                                    )}
                            </>
                        )}
                        {(services_orders.category.includes("speech_text")) && (
                            <>
                                {(inputType === 'link_input' || Text) &&
                                    (
                                        <input
                                            className="w-full h-10 border mb-1 border-gray-300 rounded p-2"
                                            placeholder={translations[lang]?.enter_link}
                                            value={Text}
                                            onChange={handleTextChange}
                                        />
                                    )}
                            </>
                        )}
                    </div >
                </>)
            }
        </>
    );
}

export default MyComponent;
